import { useEffect } from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { BenefitsMyBenefitsHomePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

import { MyBenefitsHome } from 'modules/benefits/pages/MyBenefits/MyBenefitsHome/'

const MyBenefitsHomePage = () => {
  const { employee } = useCurrentSession()
  const [myBenefitsCardBalancesQuery, { data, loading, error }] = useLazyQuery(
    BenefitsMyBenefitsHomePageDocument,
    {
      fetchPolicy: 'no-cache',
      variables: {
        employeeIds: [employee.id],
      },
    }
  )

  useEffect(() => {
    if (!employee) {
      throw new Error('Employee not found')
    }

    myBenefitsCardBalancesQuery()
  }, [employee, myBenefitsCardBalancesQuery])

  if (loading) {
    return (
      <Box gap="s8" padding="s48" alignItems="center" data-testid="benefits-root-page-loading">
        <Spinner size="s32" />
      </Box>
    )
  }

  if (error || !data?.benefits) {
    throw new Error('Benefit balances not found')
  }

  const benefitCardId =
    data?.apiCore.currentsConnection.nodes[0]?.employee?.bankingCardholder?.cards[0]?.id

  const benefitBalancesList = {
    benefitBalancesConnection: data.benefits.benefitBalancesConnection,
  }

  const benefitCategoriesList =
    data.benefits.benefitEmployeesConnection?.edges?.[0]?.node?.activeBenefits || []

  return (
    <MyBenefitsHome
      benefitBalancesList={benefitBalancesList}
      benefitCategoriesList={benefitCategoriesList}
      benefitCardId={benefitCardId}
    />
  )
}

export default MyBenefitsHomePage
